<template>
  <section class="issue-certificate">
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <form-header :title="$t('documentos.receita.titulo')" />
    <div class="container-sarah">
      <form-steps :steps="steps" :current-step="currentStep" />
      <div class="form-template general-forms" v-if="!statePage">
        <div v-if="currentStep === 0">
          <div v-if="optionData.length > 0">
            <h2 class="label">
              {{ $t('documentos.receita.selecione-receitas') }}
            </h2>
            <div class="receitas-list">
              <div v-for="o in optionData" :key="o.id" class="option-receita">
                <b-checkbox
                  v-model="o.selecionado"
                  class="option-receita-checkbox"
                  :native-value="false"
                  :disabled="o.solicitadaRecentemente"
                />
                <div
                  class="option-receita-descricao"
                  :class="{
                    'option-receita-descricao__selecionada': o.selecionado,
                    'option-receita-solicitada-recentemente':
                      o.solicitadaRecentemente
                  }"
                  @click="
                    () =>
                      (o.selecionado =
                        !o.solicitadaRecentemente && !o.selecionado)
                  "
                >
                  <div
                    v-if="o.solicitadaRecentemente"
                    class="receita-liberada-recentemente-banner"
                  >
                    <i class="icon-ic_alert-red" />
                    <div v-if="!!o.DataLiberacao">
                      {{ $t('documentos.receita.liberada-recentemente') }}
                    </div>
                    <div v-else>
                      {{ $t('documentos.receita.em-analise') }}
                    </div>
                  </div>
                  <div v-html="o.initial" class="option-receita-corpo" />
                  <div class="option-receita-detalhes">
                    <div class="option-receita-detalhes-solicitacao">
                      <div
                        :class="{
                          'option-receita-detalhes-recente':
                            o.solicitadaRecentemente && o.DataLiberacao
                        }"
                      >
                        <b>{{ $t('documentos.receita.data-solicitacao') }}</b>
                        {{ o.dataFormatada }}
                      </div>
                    </div>
                    <div class="option-receita-detalhes-liberacao">
                      <div v-if="!!o.DataLiberacao">
                        <b>{{ $t('documentos.receita.data-liberacao') }}</b>
                        {{ o.dataLiberacaoFormatada }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="nao-encontrei-receita">
              {{ $t('documentos.receita.nao-encontrei') }}
              <a @click="abrirChat">{{
                $t('documentos.receita.acessar-chat')
              }}</a>
            </div>
          </div>
          <div v-else>
            {{ $t('documentos.receita.nenhuma-receita') }}
            <a @click="abrirChat">{{
              $t('documentos.receita.acessar-chat')
            }}</a>
          </div>
        </div>
        <div v-else-if="currentStep === 1" class="receita-instrucoes-finais">
          <div>
            <h2 class="label">
              {{ $t('documentos.receita.observacao') }}
            </h2>
            <b-input
              v-model="observacao"
              type="textarea"
              :placeholder="$t('documentos.receita.observacao-placeholder')"
            />
          </div>
          <b-checkbox v-model="formularioLme">
            {{ $t('documentos.receita.formulario-lme') }}
            <div class="receita-lme-explicacao">
              {{ $t('documentos.receita.formulario-lme-explicacao') }}
            </div>
          </b-checkbox>
          <form-select
            v-model="localRetirada"
            :data="optionsRetiradas"
            :label="$t('documentos.receita.selecione-retirada')"
            @change-data="(d) => (localRetirada = d.value)"
          />
        </div>
      </div>
      <state-response
        v-if="statePage"
        img-ok-alt="Documentos"
        :img-ok-index="1"
        :state-title="stateTitle"
        :state-text="stateText"
        :button-text="buttonText"
        :status-ok="statusOk"
        @click-button="abrirDocumentos"
      />
      <form-footer
        v-else
        :disabled="disabledButton"
        :final-page="currentStep === 2"
        :ok-page="true"
        :mult-comp="true"
        :last-comp="currentStep === 1"
        @prev-step="currentStep === 0 ? abrirDocumentos() : currentStep--"
        @next-step="avancar"
        @go-to="postReport"
      />
    </div>
  </section>
</template>
<script>
import FormHeader from '@/components/shared/header/FormHeader'
import FormFooter from '@/components/atestados/FormFooter'
import FormSteps from '@/components/shared/forms/FormSteps'
import FormSelect from '@/components/atestados/FormSelect'
import StateResponse from '@/components/atestados/StateResponse'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SolicitacaoReceita',
  components: {
    FormHeader,
    FormSteps,
    FormFooter,
    FormSelect,
    StateResponse
  },
  data() {
    return {
      isFullPage: true,
      statusOk: true,
      buttonText: this.$t('botoes.continuar'),
      statePage: false,
      stateTitle: this.$t('documentos.receita.informacoes-finais-title'),
      stateText: this.$t('documentos.receita.informacoes-finais-text'),
      valueSelected: '',
      currentStep: 0,
      textInput: '',
      option: { value: this.$t('placeholders.dropdown') },
      dropdown: this.$t('placeholders.dropdown'),
      steps: [{ name: 'Receitas' }, { name: 'Instruções finais' }],
      receitas: [],
      observacao: '',
      formularioLme: false,
      formularioDispensacao: false,
      localRetirada: null,
      bloquearEnviar: false
    }
  },
  created() {
    this.obterReceitasSolicitacao()
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      getReceitasSolicitacao: 'getReceitasSolicitacao',
      paciente: 'dadosPaciente'
    }),
    optionData: {
      get() {
        return this.getReceitasSolicitacao ?? []
      }
    },
    disabledButton: {
      get() {
        if (this.currentStep === 0) {
          const someFn = (o) => o.selecionado
          return !this.optionData.some(someFn)
        } else if (this.currentStep === 1) {
          return !this.localRetirada
        } else if (this.currentStep === 2) {
          return false
        }
        return true
      },
      set(newValue) {
        let checkButton = newValue
        return checkButton
      }
    },
    optionsRetiradas() {
      let result = []
      if (!this.formularioLme) {
        const opcaoDigital = {
          key: 0,
          value: 'Receita digital - Site SARAH (www.sarah.br)'
        }
        result.push(opcaoDigital)
      }

      switch (this.paciente.CodigoUnidade) {
        case 2:
        case 11:
          const opcaoCentro = {
            key: 2,
            value: 'Pessoalmente - SARAH Centro'
          }
          const opcaoLN = {
            key: 11,
            value: 'Pessoalmente - SARAH Lago Norte'
          }
          result.push(opcaoCentro)
          result.push(opcaoLN)
          break
        case 4:
          const opcaoBHZ = {
            key: 4,
            value: 'Pessoalmente - SARAH Belo Horizonte'
          }
          result.push(opcaoBHZ)
          break
        case 5:
          const opcaoSLZ = {
            key: 5,
            value: 'Pessoalmente - SARAH São Luís'
          }
          result.push(opcaoSLZ)
          break
        case 7:
          const opcaoSSA = {
            key: 7,
            value: 'Pessoalmente - SARAH Salvador'
          }
          result.push(opcaoSSA)
          break
        case 14:
          const opcaoFOR = {
            key: 14,
            value: 'Pessoalmente - SARAH Fortaleza'
          }
          result.push(opcaoFOR)
          break
        case 17:
        case 18:
          const opcaoRIO = {
            key: 17,
            value: 'Pessoalmente - SARAH Rio de Janeiro'
          }
          result.push(opcaoRIO)
          break
        case 19:
          const opcaoMCP = {
            key: 19,
            value: 'Pessoalmente - SARAH Macapá'
          }
          result.push(opcaoMCP)
          break
        case 20:
          const opcaoBEL = {
            key: 20,
            value: 'Pessoalmente - SARAH Belém'
          }
          result.push(opcaoBEL)
          break
      }

      return result
    }
  },
  watch: {
    formularioLme() {
      if (this.formularioLme && this.optionsRetiradas.length === 1) {
        this.localRetirada = this.optionsRetiradas[0].value
      }
      if (this.localRetirada === 'Site SARAH - www.sarah.br') {
        this.localRetirada = null
      }
    }
  },
  methods: {
    ...mapActions(['obterReceitasSolicitacao', 'solicitarReceita']),
    avancar() {
      this.currentStep++

      if (this.currentStep === 1) {
        this.buttonText = this.$t('botoes.confirmar')
      } else if (this.currentStep === 2) {
        this.statePage = true
        this.buttonText = this.$t('botoes.entendi')
      }
    },
    async postReport() {
      if (this.bloquearEnviar) {
        return
      }
      this.bloquearEnviar = true
      const receitas = []
      this.optionData.forEach((o) => {
        if (o.selecionado) {
          const receita = {
            CodigoReceita: o.Codigo,
            PossuiFormularioLME: this.formularioLme,
            PossuiFormularioDispensacao: false
          }

          receitas.push(receita)
        }
      })
      const findFn = (o) => o.value === this.localRetirada
      const codigoUnidadeRetirada = this.optionsRetiradas.find(findFn)?.key
      const payload = {
        Receitas: receitas,
        CodigoUnidadeRetirada: codigoUnidadeRetirada,
        ObservacaoPaciente: this.observacao
      }
      await this.solicitarReceita(payload)
        .then(() => {
          this.buttonText = this.$t('botoes.entendi')
          this.statePage = true
          this.bloquearEnviar = false
        })
        .catch((_err) => {
          this.stateText = this.$t('erro.padrao.subtitulo')
          this.stateTitle = this.$t('erro.padrao.titulo')
          this.buttonText = this.$t('botoes.confirmar')
          this.statusOk = false
          this.statePage = true
          this.bloquearEnviar = false
        })
    },
    abrirDocumentos() {
      this.$router.push('/documentos')
    },
    abrirChat() {
      window.open('http://www.sarah.br/chat')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/warnings';
.nao-encontrei-receita {
  padding-top: 16px;
  font-size: 14px;
}
.issue-certificate {
  background-color: var(--gray-100);
  .container {
    height: 100%;
  }
  .general-forms {
    background-color: var(--bg-color-primary);
    margin-top: 1rem;
    max-height: 80vh;
    min-height: calc(100vh - 361px);
    height: 100%;
    padding: 1.5rem;
    .intro {
      font-size: 1rem;
      margin-bottom: 1.7rem;
      line-height: 1.3;
      max-width: 100%;
      text-align: justify;
    }
    .select-form {
      margin-bottom: 2.5rem;
    }
  }
  .textarea {
    max-width: 80%;
    min-width: 80%;
  }
  .warning {
    max-width: 80%;
  }
}
.receitas-list {
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
  max-height: calc(100vh - 486px);
  overflow-y: scroll;
}
.option-receita {
  display: flex;
  gap: 8px;
}
.option-receita-solicitada-recentemente {
  background-color: #fcdcdc !important;
  cursor: not-allowed !important;
}
.option-receita-checkbox {
  margin: auto;
}
.option-receita-detalhes {
  display: flex;
  margin-top: 16px;
  justify-content: space-between;
}
.option-receita-detalhes-solicitacao {
  font-size: 14px;
  color: var(--neutral-color-2);
  line-height: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.option-receita-detalhes-liberacao {
  font-size: 14px;
  color: var(--neutral-color-2);
  line-height: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.option-receita-detalhes-recente {
  color: red;
}
.option-receita-descricao {
  background-color: var(--neutral-color-5);
  padding: 8px;
  border-radius: 4px;
  flex-grow: 1;
  border: solid 1px var(--neutral-color-5);
  cursor: pointer;
  margin-right: 8px;
}
.option-receita-corpo {
  font-size: 14px;
}
.option-receita-descricao__selecionada {
  border: solid 1px #0169b3;
}
.receita-informacoes-finais {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.receita-lme-explicacao {
  font-size: 12px;
  color: var(--neutral-color-3);
}
.receita-liberada-recentemente-banner {
  background-color: #fcb2b2;
  padding: 4px;
  display: flex;
  gap: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}
.receita-instrucoes-finais {
  display: flex;
  gap: 32px;
  flex-direction: column;
}
@media (max-width: $mobile-width-breakpoint) {
  .issue-certificate {
    .general-forms {
      max-height: 100%;
      min-height: calc(100vh - 405px);
      padding-bottom: 3rem;
      .intro {
        max-width: 100%;
      }
      .select-form .dropdown {
        .dropdown-trigger {
          width: 100%;
        }
        .dropdown-menu {
          width: 100%;
        }
      }
    }
    .textarea {
      max-width: 100%;
    }
    .warning {
      max-width: 100%;
    }
  }
  .receitas-list {
    max-height: calc(100vh - 521px);
  }
  .option-receita-detalhes {
    flex-direction: column;
  }
  .option-receita-detalhes-solicitacao {
    justify-content: start;
  }
  .option-receita-detalhes-liberacao {
    flex-direction: column;
    gap: 0px;
  }
}
</style>
